// extracted by mini-css-extract-plugin
export default {"topBanner":"dH5LVa5D_B4clqtb61qv","title":"uiuobSxUwIf5r2LuMYlC"};